export default "__VITE_ASSET__c329ead5__"